import { gql } from '@apollo/client';

export const DASHBOARD_STATS_QUERY = gql`
  query DashboardStats($domainId: Int!) {
    allCustomers(condition: { domainId: $domainId }) {
      nodes {
        id
        archivedAt
      }
    }
    allJobs(condition: { domainId: $domainId }) {
      nodes {
        id
        archivedAt
      }
    }
    allQuotes(condition: { domainId: $domainId }) {
      nodes {
        id
        status
        createdAt
        archivedAt
        quoteLinesByQuoteId {
          nodes {
            id
            archivedAt
            quoteLineItemsByQuoteLineId {
              nodes {
                id
                quantity
                unitPrice
                archivedAt
              }
            }
          }
        }
      }
    }
    allWorkOrders(condition: { domainId: $domainId }, orderBy: CREATED_AT_DESC) {
      nodes {
        id
        status
        assignedTo
        type
        dueAt
        completedAt
        quoteId
        archivedAt
      }
    }
  }
`;
